
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const OurProcessPage = lazy(() => import('../pages/our-process/page'));
const WhoWeWorkWithPage = lazy(() => import('../pages/who-we-work-with/page'));
const AboutUsPage = lazy(() => import('../pages/about-us/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/our-process',
    element: <OurProcessPage />,
  },
  {
    path: '/who-we-work-with',
    element: <WhoWeWorkWithPage />,
  },
  {
    path: '/about-us',
    element: <AboutUsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
